import React from 'react';

export default (
        <svg viewBox="0 0 22 22" ><g fill="none"><g className="icon__stroke" stroke="#363C42"><g><g><path d="M8.536 1.465c1.952 1.952 1.952 5.118 0 7.07-1.953 1.953-5.119 1.953-7.072 0-1.952-1.952-1.952-5.118 0-7.07 1.953-1.953 5.119-1.953 7.072 0zM9.118 9.103L12.5 12.5" transform="translate(-1213 -159) translate(1213 159) translate(5 5)"></path></g></g></g></g></svg>
);
